module.exports = __webpack_public_path__ + "static/checkmark_white-2e528388c71d61b933acaeb9d4763ac9.png";